<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Requisition Submission" subTitle="Forms" />

    <ListRequisition />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListRequisition from "@/components/Pages/Management/Requisition/ListRequisition.vue";

export default defineComponent({
  name: "ListRequisitionPage",
  components: {
    PageTitle,
    ListRequisition,
  },
});
</script>
